module.exports = __webpack_public_path__ + "media/svg/md-01c760d5.svg";